import React from 'react';
import { AlertTriangle, Calendar, Clock, CheckCircle, DollarSign } from 'lucide-react';
import { QuickStatsCard } from '@features/cx/shared/components/QuickStatsCard';
import { usePaymentManagementSummary } from '@features/cx/payments/hooks';
import { useRemoteUtilityId } from '@shared/selectors/globalSelectors';

export const Summary: React.FC = () => {
  const remoteUtilityId = useRemoteUtilityId();
  const { data: summaryData } = usePaymentManagementSummary(Number(remoteUtilityId));

  // Extract data from the API response
  const todayCollected = summaryData?.result?.todayCollectedAmount || 0;
  const totalCollected = summaryData?.result?.totalCollectedAmount || 0;
  const collectionRate = summaryData?.result?.collectionRate || 0;
  const avgCollectionTime = summaryData?.result?.avgCollectionTime || 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <QuickStatsCard 
        title="Total Collected"
        tooltip='Total payment amount collected to date.'
        count={totalCollected}
        trendDirection="down"
        icon={<Calendar className="h-8 w-8 text-blue-500" />}
      />
      <QuickStatsCard 
        title="Received Today"
        tooltip='Payments received from consumers today.'
        count={todayCollected}
        trendDirection="up"
        icon={<DollarSign className="h-8 w-8 text-green-500" />}
      />
      <QuickStatsCard 
        title="Collection Rate"
        tooltip='Percentage of billed payments successfully collected.'
        count={collectionRate}
        trendDirection="up"
        icon={<Clock className="h-8 w-8 text-purple-500" />}
      />
      <QuickStatsCard 
        title="Avg Collection Time"
        tooltip='Average time taken by consumers to make payments.'
        count={avgCollectionTime}
        trendDirection="up"
        icon={<CheckCircle className="h-8 w-8 text-green-500" />}
      />
    </div>
  );
};
